import { DefinitionList } from "@/models/definition";

const DefinitionsHelper = {
  getDefinitionNameByType(
    id: string,
    type: string,
    definitions: DefinitionList[]
  ): string {
    const definition = definitions.find((d) => d.value === type);
    const definitinoValue = definition?.values.find((d) => d.id === id);

    return definitinoValue ? definitinoValue.name : "";
  },
};

export default DefinitionsHelper;
